<template>
  <div>
    <via-nav-bar
      title="老铁，你迷路了"
      @click-left="$router.$back()"
    />
    <via-lottie
      :animation-data="animationData"
      :height="375"
      :width="375"
    />

    <van-button
      class="btn"
      type="primary"
      @click="goHome"
    >返回首页</van-button>
  </div>
</template>

<script>
import ViaLottie from 'components/common/via-lottie'
import * as animationData from 'static/lottie/lottie-404.json'
import { Button } from 'vant'

export default {
  name: 'NotFound',
  components: {
    [ViaLottie.name]: ViaLottie,
    [Button.name]: Button
  },
  data() {
    return {
      animationData: animationData.default,
      // 保存登陆后跳转的路由名字
      redirectName: ''
    }
  },
  mounted() {
    const title_404 = document.querySelector('g[aria-label="page not found"]')
    title_404.setAttribute('fill', '#fb7299')
  },
  methods: {
    goHome() {
      this.$router.$replace({
        name: 'Home'
      })
    }
  }
}
</script>

<style scoped>
.btn {
    width: 345px;
    border-radius: 15px;
    position: absolute;
    left: 15px;
    bottom: 15px;
}
</style>
